import { ThreeDSModal } from '@/features/autorefill/components/three-ds-modal';
import { EditPersonaModal } from '@/features/persona/ui/edit-persona-modal';
import { UploadImagesModal } from '@/features/persona/ui/upload-images-modal';
import { EditStagingModal } from '@/features/staging/ui/edit-staging-modal';

import { DeleteConfirmationModal } from '@/shared/ui/delete-confirmation-modal';
import { ImageViewerModal } from '@/shared/ui/image-viewer-modal';
import { MediaInferenceViewerModal } from '@/shared/ui/media-inference-viewer-modal';

/**
 * Global modals that should be available throughout the entire application
 */
export const GlobalModals = () => {
  return (
    <>
      <ThreeDSModal />
      <EditPersonaModal />
      <EditStagingModal />
      <UploadImagesModal />
      <DeleteConfirmationModal />
      <ImageViewerModal />
      <MediaInferenceViewerModal />
      {/* Add other global modals here in the future */}
    </>
  );
};
